module.exports = __webpack_public_path__ + "static/media/Turning-Trash-into-Treasure.5c3535a8.jpg";